import { describeCheckoutIntent } from '../../utils/offer_intent';
import { SmallCheckIcon } from './AuthFlowIcons';
import '../../../stylesheets/auth-flow.css';

// What's waiting at checkout: the offer (or plan) someone picked before they
// had to sign in, verify an email, or reset a password.
const OfferIntentCard = ({ intent, status, compact = false, className = '' }) => {
  const summary = describeCheckoutIntent(intent);
  if (!summary) return null;

  return (
    <section
      className={`offer-intent ${compact ? 'offer-intent--compact' : ''} ${className}`.trim()}
      aria-label={summary.code ? `Your ${summary.code} offer` : 'Your selected plan'}
      data-offer-intent={intent.offer?.key || intent.checkoutPlan || 'plan'}
    >
      <div className="offer-intent__top">
        <span className="offer-intent__eyebrow">
          {summary.code ? `Offer · ${summary.code}` : 'Your plan'}
        </span>
        {summary.badge && <span className="offer-intent__badge">{summary.badge}</span>}
      </div>
      <div className="offer-intent__plan">
        <span className="offer-intent__name">
          {summary.planName} <span className="offer-intent__cycle">· {summary.cycleLabel}</span>
        </span>
        {summary.price && (
          <span className="offer-intent__price">
            {summary.strike && <span className="offer-intent__strike">{summary.strike}</span>}
            <span className="offer-intent__amount">{summary.price}</span>
            <span className="offer-intent__per">{summary.per}</span>
          </span>
        )}
      </div>
      <div className="offer-intent__detail">{summary.detail}</div>
      {status && (
        <div className="offer-intent__status" data-offer-intent-status>
          <SmallCheckIcon />
          <span>{status}</span>
        </div>
      )}
    </section>
  );
};

export default OfferIntentCard;
